/*
 * @Description: 录播教室
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const recordedBroadcastClassroomRouter: Array<RouteRecordRaw> = [
    {
        path: '/recordedBroadcastClassroom',
        component: Layout,
        redirect: '/recordedBroadcastClassroom/recordedBroadcastList',
        meta: { title: '录播教室' },
        children: [
            {
                path: 'recordedBroadcastList',
                component: () => import(/* webpackChunkName: "RecordedBroadcastList" */ '@/views/recordedBroadcastClassroom/recordedBroadcastList.vue'),
                name: 'RecordedBroadcastList',
                meta: { title: '录播教室列表' },
            },
            {
                path: 'recordedBroadcastInfo',
                component: () => import(/* webpackChunkName: "RecordedBroadcastInfo" */ '@/views/recordedBroadcastClassroom/recordedBroadcastInfo.vue'),
                name: 'RecordedBroadcastInfo',
                meta: { title: '录播详情' },
            }
        ]
    }
]

export default recordedBroadcastClassroomRouter
